import React, { Component } from 'react'
import { Form, Input } from 'antd'
import ExternalFiles from '../component/externalFiles'
import TipsDialog from '../component/dialog'
import { submitLogin, loginAsyncData } from '../../../service/index'
import GeetestCaptcha from '../component/captcha'
import { getCookie } from '../../../util/utils'
import DelIcon from '../../../assets/ico-delete.png'
import intl from 'react-intl-universal'
import axios from 'axios'
import './index.less'
import '../base.less'
import "swiper/css/swiper.css";
class Login extends Component {
	constructor(props) {
		super(props)
		this.captchaConfig = {
			config: {
				captchaId: "56953b22f02a8c7f4f134733e177b252",
				language: getCookie('seller_site_lang') ? getCookie('seller_site_lang').split('-')[0] == 'zh' ? 'zho' : 'eng' : 'zho',
				product: "bind",
				protocol: "https://"
			},
			handler: this.captchaHandler.bind(this)
		}
		this.state = {
			registerVisible: false,
			focusFlag: '',
			sendVerity: 0,
			verityTime: 60,
			userName: '',
			userPassword: '',
			userNameFlag: true,
			userPasswordFlag: true,
			loginErr: '',
			sellerPageLoginJsonVO: {},
			isLogin: false,
			tokenId: ''
		}
		this.handleLoginBtnClick = this.handleLoginBtnClick.bind(this)
		this.handleSendVerityCodeBtnClick = this.handleSendVerityCodeBtnClick.bind(this)
		this.handleRegisterBtnClick = this.handleRegisterBtnClick.bind(this)
		this.asyncTongdunSdk = this.asyncTongdunSdk.bind(this)
	}


	captchaHandler(captchaObj) {
		window.captchaObj = captchaObj
		captchaObj.appendTo("#captcha")
			.onReady(function () {
			})
			.onSuccess(() => {
				this.setState({
					isLogin: true,
				}, () => {
					var result = window.captchaObj.getValidate()
					const { sellerPageLoginJsonVO, userName, userPassword, tokenId } = this.state
					var dlform = document.createElement('form');
					dlform.style = "display:none;";
					dlform.method = 'post';
					dlform.id = 'sellerlogin'
					document.body.appendChild(dlform);
					Object.keys(sellerPageLoginJsonVO).map(item => {
						if (item != 'queryString' && item != 'errorname' && item != 'errorMsg') {
							let dhinput = document.createElement('input')
							dhinput.type = 'hidden'
							dhinput.name = item
							dhinput.value = sellerPageLoginJsonVO[item]
							document.getElementById('sellerlogin').appendChild(dhinput)
						} else if (item == 'queryString') {
							dlform.action = `//secure.dhgate.com/passport/sigin?${sellerPageLoginJsonVO[item]}`;
						}
					})
					Object.keys(result).map(item => {
						if (item == 'captchaId' || item == 'captcha_output' || item == 'gen_time' || item == 'lot_number' || item == 'pass_token') {
							let dhinput = document.createElement('input')
							dhinput.type = 'hidden'
							dhinput.name = item
							dhinput.value = result[item]
							document.getElementById('sellerlogin').appendChild(dhinput)
						}
					})
					let dhinput1 = document.createElement('input')
					dhinput1.type = 'hidden'
					dhinput1.name = 'username'
					dhinput1.value = userName
					document.getElementById('sellerlogin').appendChild(dhinput1)
					let dhinput2 = document.createElement('input')
					dhinput2.type = 'hidden'
					dhinput2.name = 'password'
					dhinput2.value = userPassword
					document.getElementById('sellerlogin').appendChild(dhinput2)
					let dhinput3 = document.createElement('input')
					dhinput3.type = 'hidden'
					dhinput3.name = 'blackbox'
					dhinput3.value = window.blackData|| (window._fmOpt.getinfo ? window._fmOpt.getinfo() || '' : '')
					let dhinput4 = document.createElement('input')
					dhinput4.type = 'hidden'
					dhinput4.name = 'tokenId'
					dhinput4.value = tokenId
					document.getElementById('sellerlogin').appendChild(dhinput3)
					dlform.submit();
					return
				})
			})
	}

	handleRegisterBtnClick() {
		window.open("//seller.dhgate.com/merchant/register/pageLoad.do", "_self")
	}

	handleLoginBtnClick() {
		if (this.chkUserInfo()) {
			window.captchaObj.showCaptcha();
			setTimeout(() => {
				var elem = document.getElementById('captcha')
				if (window.__exposureBuryingPoint) {
					window.__exposureBuryingPoint.init({
						module: elem,
						moduleName: 'swipeToVerify',
						spm_b: 'signin',
						moduleIndex: elem.getAttribute('spm-index') || "1",
						event_body: {
							event_code: elem.getAttribute('event-code'),
							event_data: {
								event_entity_info: {
									link_type: elem.getAttribute('link-type') || 'item'
								}
							}
						}
					});
				}
			}, 300)
		} 
	}

	chkUserInfo() {
		const { userName, userPassword } = this.state
		if (userName && userPassword) {
			return true
		} else {
			if (!userName) {
				this.setState({
					userNameFlag: false
				})
			}
			if (!userPassword) {
				this.setState({
					userPasswordFlag: false
				})
			}
		}
		return false
	}

	componentDidMount() {
		document.getElementsByTagName('body')[0].setAttribute('spm-b', 'signin')
		getCookie('seller_site_lang').split('-')[0] == 'zh' ?document.getElementsByTagName("title")[0].innerText='登录':document.getElementsByTagName("title")[0].innerText='Login'
		if (document.getElementById('sellerlogin')) {
			document.getElementById('sellerlogin').remove()
		}
		loginAsyncData().then(res => {
			this.setState({
				sellerPageLoginJsonVO: res || {},
				userName: res.errorname || '',
				loginErr: res.errorMsg || '',
				tokenId: res.tokenId||''
			}, () => {
				this.asyncTongdunSdk(res.tokenId)
			})
		}).catch(err => err)
	}

	asyncTongdunSdk(tokenId) {
		try {
			(function () {
				window._fmOpt = {
					partner: 'dunhuang',
					appName: 'dh_web_seller',
					token: tokenId,
					fmb: true,
					success: function (data) {
						window.blackData = data
					},
					fpHost: "https://fp.tongdun.net"
				};
				var cimg = new Image(1, 1);
				cimg.onload = function () {
					window._fmOpt.imgLoaded = true;
				};
				cimg.src = "https://fp.tongdun.net/fp/clear.png?partnerCode=dunhuang&appName=dh_web_seller&tokenId=" + window._fmOpt.token;
				var fm = document.createElement('script'); fm.type = 'text/javascript';
				fm.async = true;
				fm.src = ('https:' == document.location.protocol ? 'https://' : 'http://') +
					'static.tongdun.net/v3/fm.js?ver=0.1&t=' + (new Date().getTime() / 3600000).toFixed(0);
				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(fm, s);

			})();
		} catch (e) {
			window.console && console.log && console.log(e)
		}
	}

	asyncTrackSdk() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("body")[0];
				s.type = "text/javascript";
				s.src = "//js.dhresource.com/seller/common/track/trackwebsdk.js?v=1646997531153";
				x.parentNode.appendChild(s, x);
			} catch (e) { }
		})();
	}

	asyncImportJs() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://js.dhresource.com/seller/common/jquery.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
		})();
	}

	handleInputChange(ename, edata, e) {
		if (ename == 'focus') {
			this.setState({
				focusFlag: edata == 'username' ? 'username' : 'password'
			})
		} else if (ename == 'blur') {
			if (edata == 'username') {
				this.setState({
					focusFlag: '',
					userNameFlag: this.state.userName ? true : false,
				})
			} else {
				this.setState({
					focusFlag: '',
					userPasswordFlag: this.state.userPassword ? true : false
				})
			}

		} else if (ename == 'change') {
			if (edata == 'username') {
				this.setState({
					userName: e.target.value,
					loginErr: ''
				})
			} else {
				this.setState({
					userPassword: e.target.value,
					loginErr: ''
				})
			}
		}
	}

	handleSendVerityCodeBtnClick() {
		this.setState({
			verityTime: 59,
			sendVerity: 1,
		}, () => {
			this.timer = setInterval(() => {
				if (this.state.verityTime != 0) {
					this.setState({
						verityTime: this.state.verityTime - 1
					})
				} else {
					clearInterval(this.timer)
				}
			}, 1000)
		})
	}

	handleChangeRegisterBtnClick(data) {
		this.setState({
			registerType: data
		})
	}

	handleForgetBtnClick(data) {
		if (data == 'username') {
			window.open('//seller.dhgate.com/sellerextend/html/black/findUsername', '_self')

		} else {
			window.open('//seller.dhgate.com/sellerextend/html/black/findpwd1', '_self')
		}
	}

	render() {
		const { registerVisible, focusFlag, userNameFlag, userPasswordFlag, loginErr, sellerPageLoginJsonVO, userName, isLogin } = this.state
		var currentLang = getCookie('seller_site_lang') ? getCookie('seller_site_lang').split('-')[0] : 'zh'
		return (
			<div className='main-container'>
				<div className='main-container-header'>
					<ExternalFiles data={{ uri: `//seller.dhgate.com/header-${currentLang}-login-2023.html`, params: {}, staticRes: '' }}></ExternalFiles>
				</div>
				<div className='container-box'>
					<div className='login-content'>
						<div className='login-content-left'>
							{
								Object.keys(sellerPageLoginJsonVO).length > 2 && !sellerPageLoginJsonVO.status ?
									sellerPageLoginJsonVO.sellerPageLoginJsonVO ?
										<a href={JSON.parse(sellerPageLoginJsonVO.sellerPageLoginJsonVO).targetUrl||'​https://seller.dhgate.com/maijiachengzhang.html'} target="_blank">
											<img src={sellerPageLoginJsonVO.sellerPageLoginJsonVO ? JSON.parse(sellerPageLoginJsonVO.sellerPageLoginJsonVO).imageUrl : '//www.dhresource.com/dhs/oth/slp/20210827/banner.png'} alt='login' />
										</a> :
										<a href="javascript:void(0)">
										</a> : <a href="javascript:void(0)">
									</a>
							}
						</div>
						<div className='login-content-right'>
							<p className='login-content-right-title'>
								{/* 账号登录 */}
								{intl.get('seller_login_title')}
							</p>
							<p className='login-content-errormsg' style={{ visibility: loginErr ? 'visible' : 'hidden' }}>
								<span className='login-content-error-warnicon'>!</span>
								{loginErr}
							</p>
							<p className='login-content-right-titlelabel'>{intl.get('seller_findpassword_username')}</p>
							<p className='login-content-right-textarea' style={{ borderColor: focusFlag == 'username' ? '#ffcb05' : !userNameFlag ? 'red' : '#ccc' }}>
								<Input className='login-content-right-textinput' allowClear={{ clearIcon: <img src={DelIcon} alt="" /> }} placeholder={intl.get('seller-register_username_empty')} onFocus={this.handleInputChange.bind(this, 'focus', 'username')} onBlur={this.handleInputChange.bind(this, 'blur', 'username')} onChange={this.handleInputChange.bind(this, 'change', 'username')} defaultValue={userName} value={userName} />
							</p>
							<p className='login-content-errortips' style={{ visibility: !userNameFlag ? 'visible' : 'hidden' }}>{intl.get('seller-register_username_empty')}</p>
							<p className='login-content-right-titlelabel' style={{ marginTop: '40px' }}>{intl.get('seller_register_password')}</p>
							<p className='login-content-right-textarea' style={{ borderColor: focusFlag == 'password' ? '#ffcb05' : !userPasswordFlag ? 'red' : '#ccc' }}>
								<Input.Password className='login-content-right-textinput' allowClear={{ clearIcon: <img src={DelIcon} alt="" /> }} placeholder={intl.get('seller_register_password_empty')} onFocus={this.handleInputChange.bind(this, 'focus', 'password')} onBlur={this.handleInputChange.bind(this, 'blur', 'password')} onChange={this.handleInputChange.bind(this, 'change', 'password')} />
							</p>
							<p className='login-content-errortips' style={{ visibility: !userPasswordFlag ? 'visible' : 'hidden' }}>{intl.get('seller_register_password_empty')}</p>
							<div
								id="captcha"
								className={` ${this.captchaConfig.config.product === 'bind' ? "hideHeight" : null}`}
								async-exposure="true"
								event-type="expose"
								spm-b="signin"
								spm-c="swipeToVerify"
							>
								<GeetestCaptcha captchaConfig={this.captchaConfig} />
							</div>
							{
								isLogin ? <div className='loging-btn'>
									<img src='https://secure.dhgate.com/pstimage/2008/web20/seller/img/loadings.gif' alt='' />{intl.get('seller_loging_btn')}
								</div> : <div className='login-btn' onClick={this.handleLoginBtnClick} event-type="click" spam-c="signinbtn">
									{intl.get('seller_login_btn')}
								</div>
							}
							<p className='login-forgettips'>
								<span className='forget-password' onClick={this.handleForgetBtnClick.bind(this, 'password')} event-type="click" spm-c="forgotPwd">
									{intl.get('seller_login_forget_password')}
								</span>
								<span className='forget-username' onClick={this.handleForgetBtnClick.bind(this, 'username')} event-type="click" spm-c="forgotUserName">
									{intl.get('seller_login_forget_username')}
								</span>
							</p>
							<p className='login-tips'>{intl.get('seller_login_noaccount')}<span onClick={this.handleRegisterBtnClick} event-type="click" spm-c="registerNow">{intl.get('seller_login_registerbtn')}</span></p>
						</div>
					</div>
					<TipsDialog visible={registerVisible} />
				</div>
				<ExternalFiles data={{ uri: `//seller.dhgate.com/syihtml/footer-${currentLang}-2023.html`, params: {}, staticRes: '' }}></ExternalFiles>
			</div>
		)
	}
}
export default Login